var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LiveChatWidget',{attrs:{"license":"15153729","visibility":_vm.visibility,"customer-name":_vm.customerName,"customer-email":_vm.customerEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }